(function () {
  'use strict';

  document.documentElement.classList.add('js');

  if (window.RideForCause && typeof window.RideForCause.refresh === 'function') {
    window.RideForCause.refresh(document);
    return;
  }

  var state = {
    revealObserver: null,
    scrollBound: false,
    heroItems: []
  };

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function one(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function mark(node, key) {
    var attribute = 'data-rfc-bound-' + key;
    if (!node || node.hasAttribute(attribute)) return false;
    node.setAttribute(attribute, 'true');
    return true;
  }

  function initReveal(scope) {
    var items = all('.rfc .reveal:not([data-rfc-reveal-ready])', scope);
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify && Shopify.designMode) {
      items.forEach(function (item) {
        item.classList.add('visible');
        item.setAttribute('data-rfc-reveal-ready', 'true');
      });
      return;
    }

    if (!state.revealObserver) {
      state.revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            state.revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px' });
    }

    items.forEach(function (item) {
      item.setAttribute('data-rfc-reveal-ready', 'true');
      state.revealObserver.observe(item);
    });
  }

  function updateScrollUI() {
    var max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    state.heroItems = state.heroItems.filter(function (item) {
      return document.documentElement.contains(item.hero);
    });
    state.heroItems.forEach(function (item) {
      if (item.progress) item.progress.style.width = (window.scrollY / max * 100) + '%';
      var progress = Math.min(Math.max(window.scrollY - item.hero.offsetTop, 0) / Math.max(item.hero.offsetHeight, 1), 1);
      item.hero.style.setProperty('--hero-shift', Math.round(progress * 44) + 'px');
    });
  }

  function initHeroes(scope) {
    all('[data-rfc-hero]', scope).forEach(function (hero) {
      if (!mark(hero, 'hero')) return;
      state.heroItems.push({ hero: hero, progress: one('[data-rfc-progress]', hero) });
    });
    if (!state.scrollBound && state.heroItems.length) {
      state.scrollBound = true;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(function () {
            updateScrollUI();
            ticking = false;
          });
        }
      }, { passive: true });
      window.addEventListener('resize', updateScrollUI, { passive: true });
    }
    updateScrollUI();
  }

  function padDistance(value) {
    var string = String(value || 0);
    return ('000' + string).slice(-3);
  }

  function activateChapter(panel, chapter, immediate) {
    if (!panel || !chapter) return;
    all('[data-rfc-chapter]', panel).forEach(function (item) {
      item.classList.toggle('active', item === chapter);
    });

    var visual = one('[data-rfc-roadbook-visual]', panel);
    var image = one('[data-rfc-chapter-image]', panel);
    var label = one('[data-rfc-chapter-label]', panel);
    var title = one('[data-rfc-chapter-title]', panel);
    var km = one('[data-rfc-km]', panel);
    var track = one('[data-rfc-track]', panel);
    var path = one('[data-rfc-route-path]', panel);
    var chapters = all('[data-rfc-chapter]', panel);
    var index = chapters.indexOf(chapter);
    var current = one('[data-rfc-current-chapter]', panel);
    var previous = one('[data-rfc-chapter-prev]', panel);
    var next = one('[data-rfc-chapter-next]', panel);
    panel._rfcActiveChapter = index;

    all('[data-rfc-chapter-jump]', panel).forEach(function (button, buttonIndex) {
      var selected = buttonIndex === index;
      button.classList.toggle('active', selected);
      if (selected) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
    if (current) current.textContent = ('0' + (index + 1)).slice(-2);
    if (previous) previous.disabled = index === 0;
    if (next) next.disabled = index === chapters.length - 1;

    var apply = function () {
      if (image && chapter.dataset.image) image.src = chapter.dataset.image;
      if (label) label.textContent = chapter.dataset.label || '';
      if (title) title.textContent = chapter.dataset.title || '';
      if (km) km.textContent = padDistance(chapter.dataset.km);
      if (track) track.style.width = ((index + 1) / chapters.length * 100) + '%';
      if (path) path.style.strokeDashoffset = String(900 - 900 * ((index + 1) / chapters.length));
      if (visual) visual.classList.remove('is-changing');
    };

    if (visual) visual.classList.add('is-changing');
    if (immediate) apply();
    else window.setTimeout(apply, 150);
  }

  function observePanel(panel) {
    if (!panel || panel._rfcChapterObserver) return;
    var chapters = all('[data-rfc-chapter]', panel);
    if (!chapters.length) return;

    function goToChapter(index, shouldScroll) {
      var targetIndex = Math.max(0, Math.min(index, chapters.length - 1));
      var target = chapters[targetIndex];
      activateChapter(panel, target, true);
      if (shouldScroll) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    all('[data-rfc-chapter-jump]', panel).forEach(function (button) {
      button.addEventListener('click', function () {
        goToChapter(Number(button.getAttribute('data-rfc-chapter-jump')), true);
      });
    });

    var previous = one('[data-rfc-chapter-prev]', panel);
    var next = one('[data-rfc-chapter-next]', panel);
    if (previous) previous.addEventListener('click', function () {
      goToChapter((panel._rfcActiveChapter || 0) - 1, true);
    });
    if (next) next.addEventListener('click', function () {
      goToChapter((panel._rfcActiveChapter || 0) + 1, true);
    });

    activateChapter(panel, chapters[0], true);
    if (!('IntersectionObserver' in window)) return;

    panel._rfcChapterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.42) {
          activateChapter(panel, entry.target, false);
        }
      });
    }, { threshold: [0.42, 0.6], rootMargin: '-16% 0px -26%' });

    chapters.forEach(function (chapter) {
      panel._rfcChapterObserver.observe(chapter);
    });
  }

  function initStories(scope) {
    all('[data-rfc-stories]', scope).forEach(function (root) {
      if (!mark(root, 'stories')) return;
      var tabs = all('[data-rfc-story-tab]', root);
      var panels = all('[data-rfc-panel]', root);
      var activeIndex = 0;

      function activate(index, scrollTab) {
        if (!tabs.length) return;
        if (index < 0) index = tabs.length - 1;
        if (index >= tabs.length) index = 0;
        activeIndex = index;
        var id = tabs[index].getAttribute('data-rfc-story-tab');

        tabs.forEach(function (tab, tabIndex) {
          var selected = tabIndex === index;
          tab.classList.toggle('active', selected);
          tab.setAttribute('aria-selected', String(selected));
        });

        panels.forEach(function (panel) {
          var selected = panel.getAttribute('data-rfc-panel') === id;
          panel.hidden = !selected;
          if (selected) observePanel(panel);
        });

        if (scrollTab) tabs[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(index, true); });
      });

      var previous = one('[data-rfc-story-prev]', root);
      var next = one('[data-rfc-story-next]', root);
      if (previous) previous.addEventListener('click', function () { activate(activeIndex - 1, true); });
      if (next) next.addEventListener('click', function () { activate(activeIndex + 1, true); });
      root._rfcActivateStory = activate;
      activate(0, false);
    });
  }

  function initJournal(scope) {
    all('[data-rfc-journal]', scope).forEach(function (root) {
      if (!mark(root, 'journal')) return;
      var cards = all('[data-rfc-story-card]', root);
      var country = one('[data-rfc-country-filter]', root);
      var year = one('[data-rfc-year-filter]', root);
      var showing = one('[data-rfc-showing]', root);
      var total = one('[data-rfc-total]', root);
      var loadMore = one('[data-rfc-load-more]', root);
      var initial = Number(root.dataset.initialCount || 6);
      var increment = Number(root.dataset.loadCount || 6);
      var limit = initial;

      function addOptions(select, values) {
        if (!select) return;
        values.sort(function (a, b) { return String(a.label).localeCompare(String(b.label)); });
        values.forEach(function (value) {
          var option = document.createElement('option');
          option.value = value.value;
          option.textContent = value.label;
          select.appendChild(option);
        });
      }

      var countries = [];
      var countrySeen = {};
      var years = [];
      var yearSeen = {};
      cards.forEach(function (card) {
        if (!countrySeen[card.dataset.country]) {
          countrySeen[card.dataset.country] = true;
          countries.push({ value: card.dataset.country, label: card.dataset.countryLabel });
        }
        if (!yearSeen[card.dataset.year]) {
          yearSeen[card.dataset.year] = true;
          years.push({ value: card.dataset.year, label: card.dataset.year });
        }
      });
      addOptions(country, countries);
      addOptions(year, years.sort(function (a, b) { return String(b.label).localeCompare(String(a.label)); }));

      function filteredCards() {
        return cards.filter(function (card) {
          return (!country || country.value === 'all' || card.dataset.country === country.value) &&
            (!year || year.value === 'all' || card.dataset.year === year.value);
        });
      }

      function render(reset) {
        if (reset) limit = initial;
        var filtered = filteredCards();
        cards.forEach(function (card) { card.hidden = true; });
        filtered.slice(0, limit).forEach(function (card) { card.hidden = false; });
        if (showing) showing.textContent = String(Math.min(limit, filtered.length));
        if (total) total.textContent = String(filtered.length);
        if (loadMore) loadMore.hidden = filtered.length <= limit;
      }

      if (country) country.addEventListener('change', function () { render(true); });
      if (year) year.addEventListener('change', function () { render(true); });
      if (loadMore) loadMore.addEventListener('click', function () { limit += increment; render(false); });
      root._rfcRenderJournal = render;
      render(true);
    });
  }

  function initApplications(scope) {
    all('[data-rfc-application]', scope).forEach(function (root) {
      if (!mark(root, 'application')) return;
      var holder = one('[data-rfc-form]', root);
      if (!holder) return;
      var form = holder.closest('form');
      var steps = all('[data-rfc-form-step]', holder);
      var number = one('[data-rfc-step-number]', root);
      var title = one('[data-rfc-step-title]', root);
      var description = one('[data-rfc-step-description]', root);
      var route = one('[data-rfc-route-fill]', root);
      var back = one('[data-rfc-form-back]', holder);
      var next = one('[data-rfc-form-next]', holder);
      var submit = one('[data-rfc-form-submit]', holder);
      var error = one('[data-rfc-form-error]', holder);
      var stepIndex = 0;

      function showStep(index, scroll) {
        stepIndex = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach(function (step, position) {
          var active = position === stepIndex;
          step.hidden = !active;
          step.classList.toggle('active', active);
          step.setAttribute('aria-hidden', String(!active));
        });
        if (number) number.textContent = ('0' + (stepIndex + 1)).slice(-2);
        if (title) title.textContent = steps[stepIndex].dataset.title || '';
        if (description) description.textContent = steps[stepIndex].dataset.description || '';
        if (route) route.style.width = ((stepIndex + 1) / steps.length * 100) + '%';
        if (back) {
          back.disabled = stepIndex === 0;
          back.setAttribute('aria-disabled', String(stepIndex === 0));
        }
        var finalStep = stepIndex === steps.length - 1;
        if (next) next.hidden = finalStep;
        if (submit) {
          submit.hidden = !finalStep;
          submit.disabled = !finalStep;
        }
        if (error) error.hidden = true;
        if (scroll) {
          var shell = one('.application-shell', root);
          if (shell) shell.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      function validateStep(index, scroll) {
        var valid = true;
        var step = steps[index];
        all('[required]', step).forEach(function (field) {
          var fieldValid = field.type === 'checkbox' ? field.checked : field.checkValidity();
          field.classList.toggle('invalid', !fieldValid);
          if (!fieldValid) valid = false;
        });
        var group = one('[data-rfc-required-group]', step);
        if (group) {
          var groupFields = all('input[type="checkbox"]', group);
          var groupValid = !groupFields.length || groupFields.some(function (field) { return field.checked; });
          group.classList.toggle('invalid', !groupValid);
          if (!groupValid) valid = false;
        }
        if (error) error.hidden = valid;
        if (!valid && scroll) {
          var firstInvalid = one('.invalid', step) || group;
          if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return valid;
      }

      function validateAll() {
        for (var index = 0; index < steps.length; index += 1) {
          if (!validateStep(index, false)) {
            showStep(index, false);
            if (error) error.hidden = false;
            var firstInvalid = one('.invalid', steps[index]);
            if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return false;
          }
        }
        return true;
      }

      if (next) next.addEventListener('click', function () {
        if (validateStep(stepIndex, true)) showStep(stepIndex + 1, true);
      });
      if (back) back.addEventListener('click', function () { showStep(stepIndex - 1, true); });

      all('input,select,textarea', holder).forEach(function (field) {
        field.addEventListener('input', function () { field.classList.remove('invalid'); });
      });
      all('[data-rfc-counter]', holder).forEach(function (field) {
        var counter = document.getElementById(field.dataset.rfcCounter);
        var update = function () {
          if (counter) counter.textContent = field.value.length + ' / ' + field.maxLength;
        };
        field.addEventListener('input', update);
        update();
      });

      form.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || event.shiftKey || event.target.matches('textarea,button')) return;
        if (stepIndex < steps.length - 1) {
          event.preventDefault();
          if (validateStep(stepIndex, true)) showStep(stepIndex + 1, true);
        }
      });

      form.addEventListener('submit', function (event) {
        var honeypot = one('[data-rfc-honeypot]', form);
        if (honeypot && honeypot.value) {
          event.preventDefault();
          return;
        }
        if (!validateAll()) event.preventDefault();
      });

      showStep(0, false);
    });
  }

  function initAccordions(scope) {
    all('[data-rfc-accordion]', scope).forEach(function (accordion) {
      if (!mark(accordion, 'accordion')) return;
      all('details', accordion).forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          all('details', accordion).forEach(function (other) {
            if (other !== details) other.open = false;
          });
        });
      });
    });
  }

  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.body.classList.add('rfc-modal-open');
  }

  function initDialogs(scope) {
    all('.rfc', scope).forEach(function (root) {
      if (!mark(root, 'dialogs')) return;

      root.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-rfc-open-dialog]');
        if (opener) {
          event.preventDefault();
          openDialog(document.getElementById(opener.getAttribute('data-rfc-open-dialog')));
          return;
        }

        var lightboxOpener = event.target.closest('[data-rfc-lightbox]');
        if (lightboxOpener) {
          event.preventDefault();
          var lightbox = one('[data-rfc-lightbox-modal]', root);
          var lightboxImage = one('[data-rfc-lightbox-image]', root);
          if (lightboxImage) lightboxImage.src = lightboxOpener.getAttribute('data-rfc-lightbox');
          openDialog(lightbox);
          return;
        }

        var videoOpener = event.target.closest('[data-rfc-video-src]');
        if (videoOpener) {
          event.preventDefault();
          var videoModal = one('[data-rfc-video-modal]', root);
          var frame = one('[data-rfc-video-frame]', root);
          if (frame) {
            frame.src = videoOpener.getAttribute('data-rfc-video-src');
            frame.title = videoOpener.getAttribute('data-rfc-video-title') || 'Ride film';
          }
          openDialog(videoModal);
          return;
        }

        var closer = event.target.closest('[data-rfc-close]');
        if (closer) {
          var dialog = closer.closest('dialog');
          if (dialog && typeof dialog.close === 'function') dialog.close();
          else if (dialog) dialog.removeAttribute('open');
        }
      });

      all('dialog', root).forEach(function (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', function () {
          var frame = one('[data-rfc-video-frame]', dialog);
          if (frame) frame.src = '';
          if (!one('dialog[open]', document)) document.body.classList.remove('rfc-modal-open');
        });
      });
    });
  }

  function refresh(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    initReveal(target);
    initHeroes(target);
    initStories(target);
    initJournal(target);
    initApplications(target);
    initAccordions(target);
    initDialogs(target);
  }

  window.RideForCause = { refresh: refresh };
  refresh(document);

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.querySelector && event.target.querySelector('[data-rfc-story-tab]');
    if (!tab && event.target.matches && event.target.matches('[data-rfc-story-tab]')) tab = event.target;
    if (tab) tab.click();

    var card = event.target.querySelector && event.target.querySelector('[data-rfc-story-card]');
    if (!card && event.target.matches && event.target.matches('[data-rfc-story-card]')) card = event.target;
    if (card) {
      card.hidden = false;
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
})();
